import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {
  doesNotificationResourcePathMatchScope,
} from '@toolify/client/src/modules/notifications/functions/doesNotificationResourcePathMatchScope'
import {
  NotificationFilterTypeStrategyFactory,
} from '@toolify/client/src/stores/NotificationStore/factories/NotificationFilterTypeStrategyFactory'
import {INotificationListViewer} from '@toolify/client/src/modules/notifications/types/INotificationListViewer'

export function isNotificationShownToListViewer(
  notification: INotificationResponseInstance<NotificationType>,
  viewer: INotificationListViewer,
): boolean {
  if(notification.isTransient) {
    return false
  }
  if(!doesNotificationResourcePathMatchScope(notification.resourcePath, viewer.resourceType, viewer.resourceId)) {
    return false
  }
  try {
    return new NotificationFilterTypeStrategyFactory()
      .getStrategy(viewer.notificationFilterType)
      .isNotificationMatchingFilterType(notification)
  } catch {
    return false
  }
}
